import { GET_WAGON_RECIPES_SUCCESS } from "../actionTypes";

const initialState = []

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_WAGON_RECIPES_SUCCESS: {
      const wagonRecipes = action.payload;

      if (!wagonRecipes){
        return {...state};
      }

      return [...state, ...action.payload]
    }

    default:
      return state;
  }
}
